import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { AppRoutes } from './router'
import VerifyPage from './pages/Verify'
import ResetPage from './pages/Reset'
import ForgotPasswordPage from './pages/auth/forgot/page'
import { LanguageModeProvider } from './i18n/bilingual'

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    // Always reset scroll to top on route change
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <LanguageModeProvider>
      <BrowserRouter>
        <ScrollToTop />
        {/* Local routes for verification and reset */}
        <Routes>
          <Route path="/verify" element={<VerifyPage />} />
          <Route path="/reset" element={<ResetPage />} />
          <Route path="/forgot" element={<ForgotPasswordPage />} />
          {/* Removed duplicated /nutribot route; handled by AppRoutes */}
          {/* Add a catch‑all to avoid noisy warnings when a path is handled by AppRoutes */}
          <Route path="*" element={<></>} />
        </Routes>
        {/* Existing app routes */}
        <AppRoutes />
      </BrowserRouter>
    </LanguageModeProvider>
  )
}

export default App